/**
 * @description 订单
 */
export default [{
    path: '/order', //订单
    name: 'order',
    component: () => import('@/views/order/Order.vue'),
    meta: {
      title: '油柑网-订单',
      requiresAuth: false
    }
  }
]
